import styled from "styled-components";
import calendar from '../../../assets/images/calendar.svg';

const InitiatePaymentStepOnexxwxsStyle = styled.div`
  position: relative;
  width: 100%;

  form{
    width: 100%;
  }
  .form__desc{
    .step{
      color: rgba(37, 39, 51, 0.5);
      font-family: 'Mulish';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      width: 100%;
    }
    .details{
      color: #252733;
      font-family: 'Mulish';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 21px;
      width: 100%;
    }
  }
  .form__content{
    background: #FCFDFE;
    border: 1px solid #F0F1F7;
    border-radius: 5px;
    box-sizing: border-box;
    margin-top: 20px;
    padding: 10px 10px 46px 10px;
  }
  .form__content__row{
    margin-bottom: 15px;
    &:last-child{
      margin-bottom: 0;
    }
  }
  .form__content__row__item{
    position: relative;
    margin-bottom: 0;
    h2{
      color: #252733;
      font-family: 'Mulish';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 8px;
    }
    button{
      all: unset;
      cursor: pointer;
      width: 100%;
    }
    .input{
      background: rgba(55, 81, 255, 0.025);
      border: none;
      border-radius: 6px;
      color: #252733;
      font-family: 'Mulish';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      height: 40px;
      padding-left: 15px;
      position: relative;
      width: 100%;
      &::placeholder{
        color: rgba(37, 39, 51, 0.3);
      }
    }
    .--date{
      background: linear-gradient(0deg, rgba(55, 81, 255, 0.025), rgba(55, 81, 255, 0.025)), url(${calendar}) no-repeat 0px;
      background-position: 98%;
      background-size: 24px;
    }
    select{
      appearance: none;
      background: transparent;
      color: #252733;
      font-family: 'Mulish';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      margin-top: 10px;
      width: 100%;
    }
    select:required:invalid {
      color: rgba(37, 39, 51, 0.3);
    }
    img{
        margin-right: 8px;
        margin-top: 11px;
        position: absolute;
        right: 0;
        top: 0;
    }
  }
  .form__content__row__item__upload{
    background: #F7F9FE;
    border: 1.5px dashed rgba(55, 81, 255, 0.5);
    border-radius: 8px;
    height: 47px;
    position: relative;
    p{
      color: rgba(37, 39, 51, 0.3);
      font-family: 'Mulish';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 15px;
    }
    .input{
      appearance: none;
      height: 100%;
      left: 0;
      opacity: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
  .form__content__row__item__assistive-text{
    margin-top: 8px;
    p{
      color: #3751FF;
      font-family: 'Mulish';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
    }
  }
  .form__content__row__item__assistive-text__right{
    display: flex;
    p{
      color: rgba(37, 39, 51, 0.5);
      font-family: 'Mulish';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
    }
    a{
      color: #3751FF;
      font-family: 'Mulish';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      margin-left: 3.2px;
    }
  }
  .form__action{
    justify-content: flex-end;
    margin-top: 78px;
    .button{
        border-radius: 8px;
        font-family: 'Mulish';
        font-size: 16px;
        height: 50px;
        margin-bottom: 0;
    }
    .--cancel{
        background: #F5F5F5;
        color: #252733;
        font-weight: 600;
        margin-right: 20px;
        width: 102px;
    }
    .--continue{
        background: #3751FF;
        box-shadow: 0px 4px 12px rgba(55, 81, 255, 0.24);
        color: white;
        font-weight: 700;
        width: 118px;
    }
}
  
  
`;

export default InitiatePaymentStepOnexxwxsStyle;